import Immutable from "immutable";
import { useMemo } from "react";
import { recursiveCamelToSnake } from "utils/utils";

export const useConvertToImmutable = (object, excludeFields = []) =>
    useMemo(
        () =>
            Immutable.Map.isMap(object)
                ? object
                : Immutable.fromJS(object)?.mapEntries(
                      recursiveCamelToSnake(excludeFields),
                  ),
        [object],
    );
